/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import { AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";

// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }


export class TractorBeamGameAssets {

    public static INTRO_BACKGROUND:string = "introBackground";
    public static INTRO_LOGO:string = "introLogo";

    public static MAINGAME_REEL_BACKGROUND:string = "mainReelBackground";
    public static FORE_GROUND:string = "foreGround";
    public static FS_FORE_GROUND:string = "fsForeground";
    public static MAIN_GAME_BACKGROUND:string = "mainBackground";
    public static FS_BACKGROUND:string = "fsBackground";


    public static getSymbolStateTexturePath(symbolName:string, stateName:string | null = null):string {
        if(stateName == null || stateName == "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName:string, stateName:string | null = null):PIXI.Texture[] {
        return GameResources.getTextures(TractorBeamGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static RESOURCES_GROUPS:IResourcesGroupConfig = {
        intro : [
            {
                name : "fonts",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new BitmapFontAsset("yetiCountUp", "fonts/bitmapfonts/yetiCountUp.fnt"),
                    new BitmapFontAsset("yetiCountUpWhite", "fonts/bitmapfonts/yetiCountUpWhite.fnt"),
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt")
                ]
            },
            {
                name : "intro",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("intro0", "sheets/intro/intro0.json")
                ],
                animations : {
                    "introLogo" : "introLogo",
                    "radioButton" : "nav_dot",
                    "radioButtonFrame" : "nav_dot_ring",
                    "page1" : "page1",
                    "page2" : "page2",
                    "page3" : "page3",
                    "infoBg" : "infoBg"
                }
            },
            {
                name : "introJpeg",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("introJpeg0", "sheets/introJpeg/introJpeg0.json")
                    //,
                    //new TextureAsset("mainBackground", "sheets/main/mainBackground.jpg")
                ],
                animations : {
                    "introBackground" : "introBackground"
                }
            }
        ],

        main : [
            {
                name : "main",
                assets : [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json"),
                    new TextureAsset("main8", "sheets/main/main8.json"),
                    new TextureAsset("main9", "sheets/main/main9.json"),
                    new TextureAsset("main10", "sheets/main/main10.json"),
                    new TextureAsset("main11", "sheets/main/main11.json"),
                    new TextureAsset("main12", "sheets/main/main12.json"),
                    new TextureAsset("main13", "sheets/main/main13.json"),
                    new TextureAsset("main14", "sheets/main/main14.json"),
                    new TextureAsset("main15", "sheets/main/main15.json"),
                    new TextureAsset("main16", "sheets/main/main16.json"),
                    new TextureAsset("main17", "sheets/main/main17.json"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json"),


                    // BIG WIN
                ],
                animations : {
                    "button" : "ui/gameTweakerButton/button",
                    "button-disabled" : "ui/gameTweakerButton/button-disabled",
                    "mainReelBackground" : "ui/reelDividers/reels/regular/mainBeam",
                    "foreGround": "foreground",
                    "sym-hole": "ui/reelDividers/sym-hole-upper",
                    "sym-hole-upper": "ui/reelDividers/sym-hole-upper",
                    "sym-hole-lower": "ui/reelDividers/sym-hole-lower",
                    "sym-hole-mask": "sym-hole-mask",
                    //freespinAdd1": "PlusOneFreeSpin",
                    //"panel": "panel",
                    "justPanel": "panel_panel",
                    "pole": "panel_arm",

                    "baseBeam" : "ui/reelDividers/reels/redExcitement/sExcitementReel_",
                    "winEnergy" : "Betlinetest0/betlineLoop/bl_loop_",
                    "symWinLoop" : "symWinLoop/symWinFx_",

                    "bwbg" : "bigwin/bwbg/bwbg",

                    "coinSprite" : "bigwin/coinGold/CoinGold_",

                    "bigWinLvl1" : "bigwin/bigwinlvl1",
                    "bigWinLvl2" : "bigwin/bigwinlvl3",
                    "bigWinLvl3" : "bigwin/bigwinlvl2",

                    "ufo" : "shipLoop/cloakedShip/cloakedShip_",

                    //"beamUp" : "randomFeature/beamEmUp",
                    //"cloneAttack" : "randomFeature/cloneAttack",

                    "beamUpAnimation" : "randomFeature/beamEmUp/beamEmUp_",
                    "cloneAttackAnimation" : "randomFeature/cloneAttack/cloneAttack_",

                    "fsIntro" : "fsIntroSplash",
                    "fsOutro" : "fsOutroSplash",
                    "fsTextBg" : "fsIntroSplashTextBg",
                    "fsBackground" : "fsBackground",
                    "fsForeground" : "fsforeground",

                    "ufoThruster" : "shipLoop/shipThrusters/shipThrusters_",
                    "thrusterSmoke" : "shipLoop/fsIntroSmoke/fsIntroSmoke_"

                }
            },
            {
                name : "symbols",
                autoLoad : [AssetQualityLevel.HIGH],
                assets : [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),

                    new TextureAsset("panelSym-S", "sheets/symbols/tmpPanelSymbols/S.png"),
                    new TextureAsset("panelSym-L1", "sheets/symbols/tmpPanelSymbols/L1.png"),
                    new TextureAsset("panelSym-L2", "sheets/symbols/tmpPanelSymbols/L2.png"),
                    new TextureAsset("panelSym-L3", "sheets/symbols/tmpPanelSymbols/L3.png"),
                    new TextureAsset("panelSym-L4", "sheets/symbols/tmpPanelSymbols/L4.png"),
                    new TextureAsset("panelSym-M1", "sheets/symbols/tmpPanelSymbols/M1.png"),
                    new TextureAsset("panelSym-M2", "sheets/symbols/tmpPanelSymbols/M2.png"),
                    new TextureAsset("panelSym-M3", "sheets/symbols/tmpPanelSymbols/M3.png"),
                    new TextureAsset("panelSym-M4", "sheets/symbols/tmpPanelSymbols/M4.png"),

                    new TextureAsset("panelSym-W", "sheets/symbols/tmpPanelSymbols/W.png")

                ],
                animations : {
                    "S_glowBall" : "S/sSpin/comet/sSpinBase_",
                    "S_idle" : "S/sLoop/S_",

                    "M1_spin" : "M1/M1_spin",
                    "M2_spin" : "M2/M2_spin",
                    "M3_spin" : "M3/M3_spin",
                    "M4_spin" : "M4/M4_spin",

                    "L1_spin" : "L1/L1_spin",
                    "L2_spin" : "L2/L2_spin",
                    "L3_spin" : "L3/L3_spin",
                    "L4_spin" : "L4/L4_spin",

                    "W_spin" : "W/W_spin",
                    "S_spin" : "S/S_spin"
                }
            },
            {
                name : "spine",
                assets : [
                    new SpineAsset("M1_idle", "images/spine/M1.json"),
                    new SpineAsset("M2_idle", "images/spine/M2.json"),
                    new SpineAsset("M3_idle", "images/spine/M3.json"),
                    new SpineAsset("M4_idle", "images/spine/M4.json"),
                    new SpineAsset("L1_idle", "images/spine/L1.json"),
                    new SpineAsset("L2_idle", "images/spine/L2.json"),
                    new SpineAsset("L3_idle", "images/spine/L3.json"),
                    new SpineAsset("L4_idle", "images/spine/L4.json"),
                    new SpineAsset("S_idle", "images/spine/S.json"),
                    new SpineAsset("W_idle", "images/spine/W.json")
                ],
                animations : {

                }
            }
        ]
    };
}
